import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { TIMEZONES } from "../lib/time";

const offset = (tz) => {
  try {
    return new Intl.DateTimeFormat("en-GB", { timeZone: tz, timeZoneName: "shortOffset" })
      .formatToParts(new Date()).find((p) => p.type === "timeZoneName")?.value.replace("GMT", "UTC") || "";
  } catch { return ""; }
};
export const tzLabel = (tz) => `${tz.replace(/_/g, " ")} (${offset(tz) || "UTC"})`;

export function TimezoneSelect({ value, onChange, testId, className = "" }) {
  const options = value && !TIMEZONES.includes(value) ? [value, ...TIMEZONES] : TIMEZONES;
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={className} data-testid={testId}><SelectValue placeholder="Time zone" /></SelectTrigger>
      <SelectContent>
        {options.map((tz) => <SelectItem key={tz} value={tz}>{tzLabel(tz)}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
